import { action } from 'typesafe-actions'
import storageController from 'src/utils/storageController'
import authService from 'src/services/auth'
import {
  getAllContestAction,
  getUserContestAction,
} from 'src/redux/actions/xcontest'
import { AuthTypes } from '../types/auth'
import { bankTypes } from '../types/bankActionTypes'
import {
  getValidationErrorMessage,
  getErrorHelper,
} from 'src/utils/response-helpers'

import { getAllBanksAction, getMyBanksDataAction } from './bankAction'
import { getMyPlanAction } from './planAction'
import { transactionAction } from './transaction'
import { getNextOfKinAction } from './profileAction'
import { getAllInvestmentAction } from './invest'
import { getAllFaqsAction } from './faqActions'
import { getMyCardsAction } from './cards'
import { getAllPortfoliosAction } from './portfolio'

export const checkEmailAction = ({
  payload,
  onSuccessEmail,
  onErrorEmail,
}: any) => {
  return async (dispatch: any) => {
    dispatch(action(AuthTypes.SEARCH_INVITEE_CALL))
    try {
      const response: any = await authService.searchUser(payload)
      if (!response.data.data.successful) {
        onErrorEmail?.(response.data.message)
      } else {
        onSuccessEmail?.(response.data.data.server_response)
      }
      dispatch(
        action(AuthTypes.SEARCH_INVITEE_SUCCESS, response.data.data.user)
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const verifyUserAction = ({ payload, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    dispatch(action(AuthTypes.SEARCH_INVITEE_CALL))
    try {
      const response: any = await authService.searchUser(payload)
      if (!response.data.data.successful) {
        onError?.(response.data.message)
      } else {
        onSuccess?.(response.data.data.server_response)
      }
      dispatch(
        action(AuthTypes.SEARCH_INVITEE_SUCCESS, response.data.data.user)
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const verifyAccountAction = ({ onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await authService.verifyAccount()
      if (!response.data.data.successful) {
        onError?.(response.data.message)
      } else {
        onSuccess?.(response.data.data.server_response)
      }
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
export const loginAction = ({ userData, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await authService.login(userData)
      if (response.data.status) {
        const access_token = response.data.data.authorization.token
        dispatch(action(AuthTypes.UPDATE_ACCESS_TOKEN, access_token))
        dispatch(action(AuthTypes.LOGIN_REQUEST_CALL_SUCCESS))
        dispatch(action(AuthTypes.UPDATE_IS_AUTH, true))
        Promise.all([
          dispatch(getAllBanksAction()),
          dispatch(getMyCardsAction()),
          dispatch(getMyBanksDataAction()),
          dispatch(getMyPlanAction()),
          dispatch(transactionAction()),
          dispatch(getNextOfKinAction()),
          dispatch(getAllInvestmentAction()),
          dispatch(getAllFaqsAction()),
          dispatch(getNextOfKinAction()),
          dispatch(getAllContestAction()),
          dispatch(getUserContestAction()),
          dispatch(getAllPortfoliosAction()),
        ])

        storageController.setToStorage('USER_DATA', response.data.data)
        onSuccess?.(response.data.data.server_response)
      } else {
        alert('yes')
        onError?.(response.data.message)
      }
    } catch (error) {
      onError(getValidationErrorMessage(error))
    }
  }
}

export const signUpAction = ({ signUpData, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await authService.register(signUpData)

      if (!response.data.data.successful) {
        onError?.(response.data.data.server_response)
        dispatch(action(AuthTypes._CLEAR_SIGN_UP_FORM))
      } else {
        const access_token = response.data.data.authorization.token
        dispatch(action(AuthTypes.UPDATE_ACCESS_TOKEN, access_token))
        dispatch(action(AuthTypes.SIGNUP_REQUEST_SUCCESS))
        dispatch(action(bankTypes.GET_MY_BANKS_SUCCESS))
        dispatch(action(bankTypes.GET_ALL_BANKS_SUCCESS))
        dispatch(action(AuthTypes.UPDATE_IS_AUTH, true))
        Promise.all([
          dispatch(getAllBanksAction()),
          dispatch(getMyBanksDataAction()),
          dispatch(getMyPlanAction()),
          dispatch(transactionAction()),
          dispatch(getNextOfKinAction()),
          dispatch(getAllInvestmentAction()),
          dispatch(getAllFaqsAction()),
          dispatch(getMyCardsAction()),
          dispatch(getNextOfKinAction()),
          dispatch(getAllContestAction()),
          dispatch(getUserContestAction()),
          dispatch(getAllPortfoliosAction()),
        ])
        storageController.setToStorage('USER_DATA', response.data.data)
        dispatch(action(AuthTypes._CLEAR_SIGN_UP_FORM))
        onSuccess?.(response.data.data.server_response)
      }
    } catch (error) {
      onError(getValidationErrorMessage(error))
      // alert(error)
    }
  }
}

export const forgotPasswordAction = ({ userData, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await authService.forgotPassword(userData)
      if (!response.data.data.successful) {
        onError?.(response.data.data.server_response)
      } else {
        onSuccess?.(response.data.data.server_response)
      }
      dispatch(action(AuthTypes.FORGOT_PASSWORD_CALL, response.data.data))
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
